import {useCallback} from 'react';

import {useCommonDataHook} from 'src/hooks/use-common-data-hook';
import {uploadSectionContent} from 'src/openapi/admin/apis/SectionsContentApi';
import {useAppDispatch} from 'src/store/hooks';

import type {ErrorPayload, SuccessPayload} from 'src/typedef';

export const useAddSectionContent = () => {
    const apiDispatch = useAppDispatch();

    const getDispatchAction = useCallback(() => Promise.resolve({type: '', payload: {
        success: true,
        error: false,
        data: null,
    } as SuccessPayload<File | null>}), []);

    const saveDispatchAction = useCallback((multipartFile: File | null, signal: AbortSignal, sectionId?: number) => {
        if (multipartFile && sectionId) {
            return apiDispatch(uploadSectionContent({sectionId, multipartFile}, {signal}));
        } else {
            return Promise.resolve({type: '', payload: {
                success: false,
                error: true,
                data: {message: 'File is required'},
            } as ErrorPayload});
        }
    }, [apiDispatch]);

    return useCommonDataHook<File | null, number>({
        initValue: null,
        getDispatchAction,
        saveDispatchAction,
    });
};
